export default function Home() {
  return (
    <div className="hero-container">
      <img src="/images/avp_logo.png" alt="Logo" className="hero-logo" />
      <div className="hero-text">Stories coming to life</div>
    </div>
  );
}